'use strict';

var $ = require('jquery'),
    ImmobiliareFlux = require('immobiliare-flux'),
    throttle = require('../lib/raf-throttle'),
    swig = require('swig'),
    Spinner;

Spinner = ImmobiliareFlux.createComponent({
    spinner: '.gx-loader',
    tpl: swig.compile(require('../../views/snippets/spinner.html.twig')),
    initialize: function () {
        this.$spinner = this.$el.find(this.spinner);
    },
    state: {
        'visible': {
            get: function () {
                return !this.$el.hasClass('hidden');
            },
            set: function (value) {
                var _this = this,
                    spinnerTopOffset;

                if (!value) {
                    this.$el.addClass('hidden');
                    $(window).off('scroll.spinner-' + this.cid);
                } else {
                    this.$el.removeClass('hidden');
                    spinnerTopOffset = this.calculateSpinnerTopOffset();

                    if (spinnerTopOffset !== 0) {
                        this.$spinner.css('top', spinnerTopOffset);
                    }

                    $(window).on('scroll.spinner-' + this.cid, throttle(function () {
                        spinnerTopOffset = _this.calculateSpinnerTopOffset();

                        if (spinnerTopOffset !== 0) {
                            _this.$spinner.css('top', spinnerTopOffset);
                        }
                    }));
                }
            }
        }
    },
    calculateSpinnerTopOffset: function () {
        var yPos = this.$el.offset().top,
            bottomBoundary = this.$el.height() - $(window).height() + yPos,
            top = 0,
            bottom = $(window).height(),
            offsetTop = 0,
            result;

        if ($(window).scrollTop() < yPos) {
            top = yPos - $(window).scrollTop();
        } else {
            offsetTop = $(window).scrollTop() - yPos;
        }

        if (bottomBoundary < $(window).scrollTop()) {
            top = 0;
            bottom = this.$el.height() - offsetTop;
        }

        result = ((bottom - top) / 2 + offsetTop) - this.$spinner.height() / 2;

        if (result < 0) {
            result = 0;
        }

        return result;
    },
    show: function () {
        var _this = this;

        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
        }

        this.showTimeout = setTimeout(function () {
            _this.set('visible', true);
        }, 10);
    },
    hide: function () {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
        }

        this.set('visible', false);
    }
});

module.exports = Spinner;
